/**
 * UTM capture for analytics (e.g. Mixpanel). Saved at app launch so they survive
 * client-side redirects (e.g. disable-home → age-and-gender) that clear the URL.
 */
export const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'] as const;

export const UTM_STORAGE_KEY = 'vh_utm_capture';

/**
 * Reads UTM params from current URL and saves them to sessionStorage.
 * Call once at app launch (e.g. ServiceLauncher) before any redirect clears the URL.
 * Analytics (e.g. Mixpanel) can later read from the same key.
 */
export const captureUtmToStorage = (): void => {
  if (typeof window === 'undefined' || !window.location?.search) return;
  const params = new URLSearchParams(window.location.search);
  const utmProps: Record<string, string> = {};
  UTM_KEYS.forEach(key => {
    const value = params.get(key);
    if (value) utmProps[key] = value;
  });
  if (Object.keys(utmProps).length) {
    try {
      sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(utmProps));
    } catch {
      // ignore
    }
  }
};
